import { Navigate, Outlet, useLocation } from 'react-router';
import { inDesktopApp } from './screens';

/** Dentro de la app KEORA Multimedia solo existen la entrada del equipo y la parte de la app. */
export function DesktopGuard() {
  const { pathname } = useLocation();
  if (inDesktopApp() && pathname !== '/equipo' && !pathname.startsWith('/app/')) return <Navigate to="/equipo" replace />;
  return <Outlet />;
}
